import * as S from "./PhotoGuideItem.style";

interface PhotoGuideItemProps {
  data?: any;
}

export const PhotoGuideItem = ({ data }: PhotoGuideItemProps) => {
  return (
    <S.PhotoGuideItem $text={data.text ? true : false}>
      <img src={data.img} alt="사진촬영 가이드 이미지" />
      {data.text && <S.PhotoGuideText>{data.text}</S.PhotoGuideText>}
    </S.PhotoGuideItem>
  );
};
